export interface DexProvider {
  name: string;
  url: string;
}

export interface AvailableIdps {
  isLdapEnabled: boolean;
  isLocalAuthenticationEnabled: boolean;
  identityProviders: DexProvider[];
}
